import { DistributionStatus } from '../domain/enums/distribution-status';
import { MapSize } from '../domain/enums/map-size';
import { DistributionTiming } from '../domain/enums/distribution-timing';
import { AddressStatus } from '../domain/enums/address-status';
import { DistributionType } from '../domain/enums/distribution-type';

export default class Constants {
    public static DistributionStatusStrings: Map<DistributionStatus, string> = new Map([
        [DistributionStatus.Created, ''],
        [DistributionStatus.Initialized, ''],
        [DistributionStatus.Registering, ''],
        [DistributionStatus.Completed, 'STOPPED'],
    ]);

    public static StatusColors: any = {
        Red: '#ff0d00',
        Orange: '#ff9503',
        Green: '#79c123'
    };

    public static IconColors: any = {
        Start: 'rgb(102,0,0)',
        Pause: 'rgb(102,0,0)',
        End: 'rgb(102,0,0)',
        Tracking: 'rgb(0,0,0)',
        TrackingText: 'rgb(255,255,255)',
    };

    public static AddressColor: Map<AddressStatus, string> = new Map([
        [AddressStatus.Visited, 'rgb(121, 193, 35)'],
        [AddressStatus.UnVisited, 'rgb(255, 44, 33)'],
        [AddressStatus.NDZ, 'rgb(1, 1, 1)'],
        [AddressStatus.Sticker, 'rgb(1, 1, 1)'],
        [AddressStatus.OtherPk, 'rgb(1, 1, 1)'],
        [AddressStatus.FalseAddressPoint, 'rgb(1, 1, 1)']
    ]);

    public static DistributionTypeLabel: Map<DistributionType, string> = new Map([
        [DistributionType.ToDistribute, 'ToDistribute'],
        [DistributionType.NDZ, 'NDZ'],
        [DistributionType.Sticker, 'Sticker'],
        [DistributionType.OtherPk, 'OtherPk'],
        [DistributionType.FalseAddressPoint, 'FalseAddressPoint']
    ]);

    public static DeviceColors: string[] = [
        'rgb(0, 149, 201)', // cyan
        'rgb(177, 123, 64)', // brown
        'rgb(135, 120, 243)', // lavender
        'rgb(255, 112, 70)', // salmon
        'rgb(119, 125, 114)', // grey
        'rgb(130, 173, 31)', // olive
        'rgb(178, 41, 41)', // darkred
        'rgb(0, 51, 120)', // darkblue
        'rgb(119, 4, 63)', // darkpurple
        'rgb(0, 48, 0)', // darkgreen
    ];

    public static MapClass: Map<MapSize, string> = new Map([
        [MapSize.None, ''],
        [MapSize.Small, 'map-small'],
        [MapSize.Half, 'map-half'],
        [MapSize.Full, 'map-full'],
    ]);

    public static Projections: { [key: string]: string } = {
        Data: 'EPSG:4326',
        Map: 'EPSG:3857'
    };

    public static Extents: { [key: string]: number[] } = {
        Belgium: [278298.73, 6360130.74, 712444.74, 6712007.50]
    };

    public static DistributionTimingFilterOptions: any = [
        { value: null, displayValue: 'SHOW_ALL' },
        { value: DistributionTiming.Early, displayValue: 'DISTRIBUTION_TIMING_EARLY' },
        { value: DistributionTiming.OnTime, displayValue: 'ON_TIME' },
        { value: DistributionTiming.Late, displayValue: 'DISTRIBUTION_TIMING_LATE' },
    ];

    public static DistributionTimingClass: Map<DistributionTiming, string> = new Map([
        [DistributionTiming.OnTime, 'DISTRIBUTION_TYPE_ON_TIME_OVERVIEW'],
        [DistributionTiming.Early, 'DISTRIBUTION_TYPE_EARLY'],
        [DistributionTiming.Late, 'DISTRIBUTION_TYPE_LATE'],
        [DistributionTiming.Both, 'DISTRIBUTION_TYPE_BOTH']
    ]);

    public static TimeFormat: string = 'HH:mm';
    public static DateFormat: string = 'dd/MM/yyyy';
    public static MomentDateTimeFormat: string = 'DD/MM/YYYY HH:mm';
    public static MomentDateFormat: string = 'DD/MM/YYYY';
    public static ShortDateFormat: string = 'DD/MM';
    public static KendoDateTimeFormat: string = `{0:${Constants.DateFormat} ${Constants.TimeFormat}}`;
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/constants.ts